import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { DettaglioEsito } from '../../../models/dettaglio-esito';
import { Esito } from '../../../models/esito';
import { EsitiMeritoUpdate } from './esiti-merito-update';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [esiti-merito-update-mod]',
  templateUrl: 'esiti-merito-update-mod.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class EsitiMeritoUpdateMod {
  @Output() onReturn: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('formMerito') formMerito: EsitiMeritoUpdate;

  inizializza(urlAddMerito: string, esito: Esito, dettaglioEsito: DettaglioEsito, urlSezioneControparti: string, idSezioneControparti: string, urlSezioneClassificazioni: string, idSezioneClassificazione: string, idSezioneEsiti: string, idPratica: string, urlSezioneEsiti: string) {
    this.formMerito.inizializza(idSezioneEsiti, urlSezioneEsiti, urlAddMerito, esito, dettaglioEsito, urlSezioneControparti, idSezioneControparti, urlSezioneClassificazioni, idSezioneClassificazione, idPratica);
    openModal('modalmodmeritiupdate');
  }

  createForm() {
    this.formMerito.createForm();
  }

  manageModal() {
      closeModal('modalmodmeritiupdate');
      this.onReturn.emit();
  }
}
